import PropTypes from "prop-types";
import { useState } from "react";

import Modal from "react-modal";
import {
    TooltipButton,
    Icon,
    Content,
    Top,
    Main,
    Title,
    ImageContainer,
    Image
} from "./Tooltip.styled";

export default function Tooltip({ item }) {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    function openModal(event) {
        event.preventDefault();
        setModalIsOpen(true);
    }

    function closeModal(event) {
        event.preventDefault();
        setModalIsOpen(false);
    }

    const image = item?.images?.[0] ?? null;

    return (
        <div>
            <TooltipButton data-event="click focus" onClick={openModal}>
                <Icon
                    src="/images/icon-info.svg"
                    alt=""
                    width="15px"
                    loading="lazy"
                />
            </TooltipButton>
            <Modal
                isOpen={modalIsOpen}
                contentLabel={item?.title}
                onRequestClose={closeModal}
                ariaHideApp={false}
                className="react-modal"
                overlayClassName="react-modal-overlay"
                closeTimeoutMS={400}
            >
                <Content>
                    <Top>
                        <button onClick={closeModal}>
                            <Icon
                                src="/images/icon-close-peach.svg"
                                maxWidth="25px"
                                loading="lazy"
                            />
                        </button>
                    </Top>
                    <Main>
                        <Title>{item?.title}</Title>
                        {image && (
                            <ImageContainer>
                                <Image
                                    src={image?.url}
                                    alst={image?.alt}
                                    loading="lazy"
                                />
                            </ImageContainer>
                        )}
                        {item?.shortDescription && (
                            <div>{item?.shortDescription}</div>
                        )}
                    </Main>
                </Content>
            </Modal>
        </div>
    );
}

Tooltip.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
        thumbnail: PropTypes.shape({
            url: PropTypes.string,
            alt: PropTypes.string
        }),
        images: PropTypes.arrayOf(
            PropTypes.shape({
                url: PropTypes.string,
                alt: PropTypes.string
            })
        ),
        shortDescription: PropTypes.string
    }).isRequired
};
